import React from "react";
import "./style.css";

export default function PrivacyPage() {
  return (
    <div className="privacy">
      <div className="container privacy__container">

        <h1 className="privacy__title">Privacy Policy</h1>
        <p className="privacy__updated">Last Updated: March 2026</p>

        <section className="privacy__section">
          <p>
            BioClock-in ("we", "our", "us") respects your privacy and is committed
            to protecting your personal information. This Privacy Policy explains
            how we collect, use, store, and protect information when you use our
            website, biometric devices, and workforce management services.
          </p>
        </section>

        <section className="privacy__section">
          <h2>1. Information We Collect</h2>

          <h3>Personal Information</h3>
          <ul>
            <li>Name and surname</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Company name</li>
            <li>Contact details provided through forms</li>
          </ul>

          <h3>Employee & Attendance Data</h3>
          <ul>
            <li>Employee names or IDs</li>
            <li>Clock-in and clock-out times</li>
            <li>Work hours and schedules</li>
            <li>Leave and absence data</li>
            <li>Payroll-related calculations</li>
          </ul>

          <h3>Biometric Data</h3>
          <p>
            BioClock-in uses biometric authentication such as fingerprint templates.
            We do NOT store fingerprint images. Only encrypted mathematical templates
            are stored for identity verification.
          </p>
        </section>

        <section className="privacy__section">
          <h2>2. How We Use Information</h2>
          <ul>
            <li>Provide and operate our services</li>
            <li>Manage attendance and workforce data</li>
            <li>Improve system performance</li>
            <li>Provide customer support</li>
            <li>Communicate with customers</li>
            <li>Comply with legal obligations</li>
          </ul>
          <p className="privacy__highlight">
            We do not sell personal information to third parties.
          </p>
        </section>

        <section className="privacy__section">
          <h2>3. Data Ownership</h2>
          <p>
            Businesses using BioClock-in remain the owners of their employee data.
            BioClock-in acts only as a data processor on behalf of the client organization.
          </p>
        </section>

        <section className="privacy__section">
          <h2>4. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures including
            encryption, secure servers, access controls, and monitoring to protect
            your information.
          </p>
        </section>

        <section className="privacy__section">
          <h2>5. Biometric Data Protection</h2>
          <ul>
            <li>Stored as encrypted templates</li>
            <li>Used only for identity verification</li>
            <li>Not shared with unauthorized parties</li>
            <li>Retained only as required for service delivery</li>
          </ul>
        </section>

        <section className="privacy__section">
          <h2>6. Data Sharing</h2>
          <p>
            We may share information with client organizations, trusted service
            providers, or when required by law. We never sell or rent data.
          </p>
        </section>

        <section className="privacy__section">
          <h2>7. Data Retention</h2>
          <p>
            Data is retained only as long as necessary to provide services,
            comply with legal obligations, and meet contractual requirements.
          </p>
        </section>

        <section className="privacy__section">
          <h2>8. Your Rights</h2>
          <p>
            Depending on applicable laws, individuals may request access,
            correction, deletion, or restriction of their personal data.
          </p>
        </section>

        <section className="privacy__section">
          <h2>9. Cookies</h2>
          <p>
            Our website may use cookies to improve user experience and analyze
            traffic. Users can manage cookies through browser settings.
          </p>
        </section>

        <section className="privacy__section">
          <h2>10. Contact Information</h2>
          <p>
            If you have questions about this Privacy Policy, contact us:
          </p>

          <div className="privacy__contact">
            <p><strong>BioClock-in</strong></p>
            <p>Email: support@bioclock-in.com</p>
            <p>Website: www.bioclock-in.com</p>
            {/* <p>Phone: +27 XXX XXX XXX</p> */}
          </div>
        </section>

        <section className="privacy__section">
          <h2>11. Compliance</h2>
          <p>
            BioClock-in aims to comply with applicable data protection laws,
            including the Protection of Personal Information Act (POPIA)
            in South Africa.
          </p>
        </section>

      </div>
    </div>
  )
}